<ion-content class="ion-padding">
  <h4 *ngIf="username">{{username}}'s Mix Tape</h4>
  <ion-toolbar>
    <ion-row *ngIf="username">
      <ion-button *ngIf="displayProfileButton" color="medium" id="profile-viewer-modal" (click)="openProfileModal()" size="small">Profile<ion-icon name="person-circle-outline" slot="end"></ion-icon></ion-button>
      <ion-button color="primary" (click)="likeAudio()"  size="small" [disabled]="!(globalService.$loggedIn | async)">
        Likes
        <ion-icon name="caret-up-outline"></ion-icon>
        {{ likes$ | async }}
      </ion-button>
      <ion-button color="tertiary" (click)="goToAudioLocation()" size="small">
        Go To
        <ion-icon name="airplane"></ion-icon>
      </ion-button>
    </ion-row>
  <ion-buttons slot="end">
    <ion-button (click)="cancel()" [strong]="true">Close<ion-icon name="close"></ion-icon></ion-button>
  </ion-buttons>
</ion-toolbar>
  <div [hidden]="description.length === 0 && !((globalService.$loggedIn | async) && authenticator.user?.username === username)">
    <ion-item-divider>
      <ion-label>
        <h1>Description</h1>
      </ion-label>
    </ion-item-divider>
    <ion-textarea
      label="Audio Description"
      [autoGrow]="true"
      [(ngModel)]="description"
      maxLength="500"
      placeholder="Add a description for your mix tape"
      [readonly]="!(globalService.$loggedIn | async) || authenticator.user?.username !== username"
      [disabled]="!descriptionEnabled"
    >
    </ion-textarea>
  </div>
  <div [hidden]="!((globalService.$loggedIn | async) && authenticator.user?.username === username)">
    <ion-button [hidden]="descriptionEnabled" (click)="editDescription()">{{ description.length > 0 ? "Edit Description" : "Add Description" }}</ion-button>
    <ion-button color="success" [hidden]="!descriptionEnabled" (click)="updateDescription()">Submit</ion-button>
    <ion-button color="medium" [hidden]="!descriptionEnabled" (click)="cancelDescription()">Cancel</ion-button>
  </div>
  <ion-button color="success" (click)="playAudio()" size="small">
    Play Mix Tape <ion-icon name="play-circle-outline"></ion-icon>
  </ion-button>
  <ion-item-divider>
    <ion-label>
      <h1>Comments</h1>
    </ion-label>
  </ion-item-divider>
  <ion-col [hidden]="!(globalService.$loggedIn | async)">
    <h2>Add new comment</h2>
    <ion-textarea
    label="Add new comment"
    placeholder="What do you think about this?"
    [autoGrow]="true"
    [ngModel]="(myComment$ | async)"
    maxlength="500"
    [disabled]="false"
    (ngModelChange)="trackNewCommentText($event)"
    >
    </ion-textarea>
    <ion-button color="secondary" (click)="submitComment()" [disabled]="myComment$.getValue().length === 0" size="small">
      Submit
      <ion-icon name="chatbox-outline"></ion-icon>
    </ion-button>
  </ion-col>
  <ion-list *ngFor="let comment of allComments$ | async; index as position" class="ion-padding-bottom">
    <ion-card>
      <ion-card-header>
        <ion-row>
          <ion-col size="10">
            <ion-card-subtitle><ion-chip (click)="viewProfile(comment.authorName)" color="primary"><b>{{comment.authorName}}</b></ion-chip>: {{convertTimestampToDateTime(comment.timestamp)}}
            </ion-card-subtitle>
          </ion-col>
          <ion-col size="1">
              <ion-button *ngIf="comment.authorName === authenticator.user?.username && (globalService.$loggedIn | async)" color="danger" (click)="deleteComment(comment)" size="small" fill="clear">
                <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
              </ion-button>
          </ion-col>
        </ion-row>
      </ion-card-header>
      <ion-card-content>
        {{comment.commentText}}
      </ion-card-content>
    </ion-card>
  </ion-list>
  <ion-infinite-scroll (ionInfinite)="loadMore($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
  <div style="padding-bottom: 300px !important;"></div>
</ion-content>